var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMarkCircle11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download-Assets---Failed-to-Export-Assets-Notification",
    transform: "translate(-921 -156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mac/Monochrome/11x11/exclamation.mark.circle",
    transform: "translate(921 156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    stroke: "currentColor",
    cx: 5.5,
    cy: 5.5,
    r: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "currentColor",
    x: 5,
    y: 2.5,
    width: 1,
    height: 3.5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    fill: "currentColor",
    x: 5,
    y: 7,
    width: 1,
    height: 1,
    rx: 0.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkCircle11);
export default __webpack_public_path__ + "static/media/exclamation-mark-circle-11.5012a413.svg";
export { ForwardRef as ReactComponent };